import { render, staticRenderFns } from "./MinMaxWin.vue?vue&type=template&id=60699814&"
import script from "./MinMaxWin.vue?vue&type=script&lang=js&"
export * from "./MinMaxWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports